import React, { useState } from "react";
import Seo from "../components/Seo";
import SectionEyebrow from "../components/SectionEyebrow";
import RevealOnScroll from "../components/RevealOnScroll";
import JobCard from "../components/JobCard";
import ApplicationForm from "../components/ApplicationForm";
import BigCTA from "../components/BigCTA";
import { JOBS, WORK_VALUES } from "../data/content";

const SPONTANEA = "Candidatura spontanea";

const JoinTeam = () => {
  const [prefill, setPrefill] = useState("");

  const handleApply = (title) => {
    setPrefill(title);
    setTimeout(() => {
      const el = document.getElementById("application-form-section");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 50);
  };

  return (
    <>
      <Seo
        title="Team OnSports: founder, strategist, content producer | OnSports"
        description="Il team OnSports, l'Impact Sports Consultancy italiana fondata nel 2018. Strategist, content producer, performance specialist con esperienza nei brand sportivi."
        path="/join-the-team"
      />

      <section className="bg-dodgers text-galactico pt-40 pb-24 md:pt-52 md:pb-32" data-testid="join-hero">
        <div className="container-os">
          <RevealOnScroll>
            <SectionEyebrow>Carriere</SectionEyebrow>
          </RevealOnScroll>
          <RevealOnScroll delay={0.1}>
            <h1 className="display-h1 mt-8 max-w-[18ch]">
              Costruisci il futuro<br />
              dell'<span className="text-lime">impatto</span><br />
              nello sport.
            </h1>
          </RevealOnScroll>
          <RevealOnScroll delay={0.2}>
            <p className="mt-9 body-lg opacity-85 max-w-[60ch]">
              Cerchiamo persone che vogliono ridefinire il modo in cui le organizzazioni
              investono nello sport. Non esecutori, ma partner strategici.
            </p>
          </RevealOnScroll>
        </div>
      </section>

      <section className="section-pad bg-galactico text-dodgers" data-testid="join-why">
        <div className="container-os">
          <div className="grid grid-cols-12 gap-8 md:gap-12">
            <div className="col-span-12 md:col-span-5">
              <RevealOnScroll>
                <SectionEyebrow>Perché OnSports</SectionEyebrow>
              </RevealOnScroll>
              <RevealOnScroll delay={0.1}>
                <h2 className="display-h2 mt-6">
                  Non produciamo contenuti.<br />
                  Costruiamo <span className="text-lime">sistemi di impatto</span>.
                </h2>
              </RevealOnScroll>
            </div>
            <div className="col-span-12 md:col-span-7 space-y-6 text-[1.0625rem] md:text-[1.125rem] leading-relaxed max-w-[64ch]">
              <RevealOnScroll delay={0.15}>
                <p>
                  La maggior parte delle agenzie ti chiede di eseguire. Qui ti chiediamo
                  di pensare prima, capire i numeri, parlare con il C-level del cliente e
                  poi decidere cosa fare. È un modo diverso di lavorare nello sport.
                </p>
              </RevealOnScroll>
              <RevealOnScroll delay={0.2}>
                <p>
                  Siamo una boutique. Ogni nuova persona pesa moltissimo: cresce
                  velocemente, ha responsabilità reali su clienti reali, contribuisce alla
                  metodologia. Non c'è la trincea dove nasconderti.
                </p>
              </RevealOnScroll>
              <RevealOnScroll delay={0.25}>
                <p>
                  In cambio: stipendi competitivi, progetti che vorrai mettere nel
                  portfolio, una community di consulenti e atleti che amplia il tuo
                  network e — soprattutto — la libertà di rifiutare lavoro mediocre.
                </p>
              </RevealOnScroll>
            </div>
          </div>
        </div>
      </section>

      <section className="section-pad bg-dodgers text-galactico" data-testid="join-values">
        <div className="container-os">
          <RevealOnScroll>
            <SectionEyebrow>Come lavoriamo</SectionEyebrow>
          </RevealOnScroll>
          <RevealOnScroll delay={0.1}>
            <h2 className="display-h2 mt-6 max-w-[18ch]">Quattro principi operativi.</h2>
          </RevealOnScroll>
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-7">
            {WORK_VALUES.map((v, i) => (
              <RevealOnScroll key={v.num} delay={i * 0.07}>
                <div
                  className="pillar-card border border-galactico/15 bg-galactico/[0.03] p-7 md:p-10"
                  data-testid={`work-value-${v.num}`}
                >
                  <SectionEyebrow num={v.num}>{v.title}</SectionEyebrow>
                  <h3 className="font-display text-xl md:text-2xl leading-tight mt-5 mb-3">{v.title}</h3>
                  <p className="text-[1rem] md:text-[1.0625rem] opacity-85 leading-relaxed">{v.body}</p>
                  <span className="mt-6 block h-[2px] w-12 bg-lime" />
                </div>
              </RevealOnScroll>
            ))}
          </div>
        </div>
      </section>

      {/* POSIZIONI APERTE — accordion */}
      <section className="section-pad bg-galactico text-dodgers" data-testid="join-jobs">
        <div className="container-os">
          <RevealOnScroll>
            <SectionEyebrow>Posizioni aperte</SectionEyebrow>
          </RevealOnScroll>
          <RevealOnScroll delay={0.1}>
            <h2 className="display-h2 mt-6">Posizioni aperte.</h2>
          </RevealOnScroll>
          <RevealOnScroll delay={0.18}>
            <p className="mt-6 body-lg opacity-85 max-w-[60ch]">
              Quattro ruoli aperti, tutti basati a Milano con modalità hybrid. Clicca su
              una posizione per leggere il dettaglio.
            </p>
          </RevealOnScroll>
          <div className="mt-12" data-testid="jobs-list">
            {JOBS.map((j, i) => (
              <JobCard key={j.title} job={j} onApply={handleApply} testId={`job-${i}`} />
            ))}
          </div>
        </div>
      </section>

      {/* CANDIDATURA SPONTANEA */}
      <section
        className="section-pad bg-dodgers text-galactico border-t border-galactico/10"
        data-testid="join-spontanea"
      >
        <div className="container-os">
          <div className="grid grid-cols-12 gap-8 md:gap-12">
            <div className="col-span-12 md:col-span-7">
              <RevealOnScroll>
                <SectionEyebrow>Candidatura spontanea</SectionEyebrow>
              </RevealOnScroll>
              <RevealOnScroll delay={0.1}>
                <h2 className="display-h2 mt-6 max-w-[20ch]">Non vedi la tua posizione?</h2>
              </RevealOnScroll>
              <RevealOnScroll delay={0.18}>
                <p className="mt-7 body-lg opacity-85 max-w-[60ch]">
                  Se il tuo profilo non rientra nelle posizioni aperte ma pensi di poter
                  contribuire al nostro lavoro, scrivici. Leggiamo ogni candidatura.
                </p>
              </RevealOnScroll>
              <RevealOnScroll delay={0.24}>
                <div className="mt-10">
                  <button
                    type="button"
                    onClick={() => handleApply(SPONTANEA)}
                    className="btn-os btn-primary"
                    data-testid="cta-spontanea"
                  >
                    <span>Invia candidatura spontanea</span>
                    <span className="arrow" aria-hidden="true">→</span>
                  </button>
                </div>
              </RevealOnScroll>
            </div>
          </div>
        </div>
      </section>

      {/* FORM */}
      <section
        id="application-form-section"
        className="section-pad bg-dodgers text-galactico"
        data-testid="join-application"
      >
        <div className="container-os">
          <div className="grid grid-cols-12 gap-8 md:gap-12">
            <div className="col-span-12 md:col-span-5">
              <RevealOnScroll>
                <SectionEyebrow>{prefill || "Candidatura"}</SectionEyebrow>
              </RevealOnScroll>
              <RevealOnScroll delay={0.1}>
                <h2 className="display-h2 mt-6">
                  {prefill && prefill !== SPONTANEA
                    ? "Candidati per questa posizione."
                    : "Mandaci la tua storia."}
                </h2>
              </RevealOnScroll>
              <RevealOnScroll delay={0.18}>
                <p className="mt-7 body-lg opacity-85 max-w-[44ch]">
                  Compila il modulo qui accanto. Tutti i campi contrassegnati con * sono
                  obbligatori. Ti risponderemo entro 10 giorni lavorativi.
                </p>
              </RevealOnScroll>
              {prefill && (
                <RevealOnScroll delay={0.24}>
                  <div className="mt-8">
                    <button
                      type="button"
                      onClick={() => setPrefill("")}
                      className="font-condensed uppercase tracking-widest text-sm underline opacity-80 hover:opacity-100"
                      data-testid="reset-prefill"
                    >
                      ← Riparti senza posizione pre-selezionata
                    </button>
                  </div>
                </RevealOnScroll>
              )}
            </div>
            <div className="col-span-12 md:col-span-7 bg-galactico text-dodgers p-7 md:p-10 border border-dodgers/20">
              <RevealOnScroll delay={0.18}>
                <ApplicationForm
                  prefillPosition={prefill}
                  onSubmitted={() => setPrefill("")}
                />
              </RevealOnScroll>
            </div>
          </div>
        </div>
      </section>

      <BigCTA />
    </>
  );
};

export default JoinTeam;
